export class SplatArea {
  constructor(rectangle, frameNumber) {
    this.rectangle = rectangle;
    this.frameNumber = frameNumber;
  }
}

export const SPLAT_PADDING = 2.1;
export const SPEED_PADDING = 0.7;
